import produce from "immer";
import { DEFAULT_ACTION, FORMDATA, SETFORMDATA , SETVALUEFETCH} from "./constants";

export const initialState = {
  formData: [],
  valuefetched: false
};

const uploadInvoiceReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action?.type) {
      case DEFAULT_ACTION:
        break;
      case FORMDATA:
        draft.formData = action?.payload;
        break;
      case SETFORMDATA:
        draft?.formData?.forEach((result, key) => {
          if (result?.block_parameters_id === action?.payload?.block_parameters_id) {
            draft.formData[key].value = action?.payload?.value;
          }
        })
        break;
      case SETVALUEFETCH:
        draft.valuefetched = action.payload;
        break;
    }
  });

export default uploadInvoiceReducer;
